import React, { useState } from "react";
import {
  db,
  auth,
  createUserWithEmailAndPassword,
  addDoc,
  collection,
  query,
  where,
  getDocs,
  doc,
  deleteDoc,
} from "../../firebase/firebase";
import signupVideo from '../../assets/img/2k.mp4'
import styles from "./signup.module.css"; 
import Header from "../../components/header/header/header";

const GetStarted = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [medicalLicenseNumber, setMedicalLicenseNumber] = useState("");
  const [reason, setReason] = useState("");
  // Add state for referral sources
  const [referralSources, setReferralSources] = useState({
    search: false,
    social: false,
    friend: false,
    event: false,
    other: false
  });

  // Popup states
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all required fields are filled
    if (!name || !email || !role || !country || !city || !phoneNumber) {
      setShowError(true);
      setErrorMessage("Veuillez remplir tous les champs obligatoires !");
      return;
    }
    try {
      // Check if user exists in candidates collection and if emailSend = 1
      const candidatesRef = collection(db, "candidates");
      const q = query(candidatesRef, where("email", "==", email), where("emailSent", "==", 1));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setShowError(true);
        setErrorMessage("Votre email n'est pas autorisé ou n'a pas encore été validé.");
        return;
      }

      // Get the candidate document
      const candidateDoc = querySnapshot.docs[0];
      const candidateData = candidateDoc.data();
      
      if (!candidateData.uid) {
        setShowError(true);
        setErrorMessage("Votre compte n'est pas correctement configuré. Veuillez contacter l'administrateur.");
        return;
      }
      
      const uid = candidateData.uid;

      // Check if this is an admin candidate
      if (candidateData.isAdmin) {
        // Add user to admins collection
        await addDoc(collection(db, "admins"), {
          name: candidateData.adminData.name,
          email: candidateData.email,
          role: candidateData.adminData.role,
          phone: candidateData.adminData.phone,
          uid: uid,
          createdAt: new Date(),
        });
      } else {
        // Add user to medecins collection
        await addDoc(collection(db, "medecins"), {
          name,
          email,
          role,
          country,
          city,
          phoneNumber,
          medicalLicenseNumber,
          reason,
          uid: uid,
          createdAt: new Date(),
        });
      }

      // Delete the user from candidates collection
      const candidateRef = doc(db, "candidates", candidateDoc.id);
      await deleteDoc(candidateRef);
      
      // Show success popup and redirect
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        window.location.href = "/";
      }, 3000);
      
      // Reset form fields
      setName("");
      setEmail("");
      setRole("");
      setCountry("");
      setCity("");
      setPhoneNumber("");
      setMedicalLicenseNumber("");
      setReason("");
      setReferralSources({
        search: false,
        social: false,
        friend: false,
        event: false,
        other: false
      });
    } catch (err) {
      setShowError(true);
      setErrorMessage(`Erreur lors de la création du compte: ${err.message}`);
    }
  };

  const handleReferralChange = (source) => {
    setReferralSources({
      ...referralSources,
      [source]: !referralSources[source]
    });
  };

  return (
    <div>
      <Header/>
      <main>
      {showSuccess && (
          <div className={styles.successPopup}>
            <div className={styles.popupContent}>
              <h2>Compte créé avec succès !</h2>
              <button 
                onClick={() => setShowSuccess(false)} 
                className={styles.closeButton}
              >
                Fermer
              </button>
            </div>
          </div>
        )}

        {showError && (
          <div className={styles.errorPopup}>
            <div className={styles.popupContent}>
              <p>{errorMessage}</p>
              <button 
                onClick={() => setShowError(false)} 
                className={styles.closeButton}
              >
                Fermer
              </button>
            </div>
          </div>
        )}
        <div className={styles.signupContainer}>
          <div className={styles.imageSection}>
            <video 
              autoPlay 
              loop 
              playsInline
              muted 
              className={styles.signupVideo}
            >
              <source src={signupVideo} type="video/mp4" />
                Votre navigateur ne prend pas en charge les vidéos HTML5.
            </video>
          </div>
          <div className={styles.formSection}>
            <h1 className={styles.heading}>Créez votre compte</h1>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="name"
                  placeholder=" "
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <label className={`${styles.label} ${styles.nameLabel}`} >
                  Nom et prénom <span className={styles.required}>*</span>
                </label>
              </div>
              {/* Role selection - unchanged */}
              <div className={styles.formGroup}>
                <label className={styles.roleLabel}>
                  Vous êtes <span className={styles.required}>*</span>
                </label>
                <div className={styles.radioGroup}>
                  <label className={styles.radioLabel}>
                    <input type="radio" name="role" value="dentiste omnipraticien" onChange={(e) => setRole(e.target.value)} />
                    Dentiste omnipraticien
                  </label>
                  <label className={styles.radioLabel}>
                    <input type="radio" name="role" value="orthodontiste" onChange={(e) => setRole(e.target.value)} />
                    Orthodontiste
                  </label>
                </div>
              </div>
              
              
              
              
              {/* Professional address - fixed */}
              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="professionalAddress"
                  placeholder=" "
                  value={reason} // Using reason for professional address
                  onChange={(e) => setReason(e.target.value)}
                />
                <label className={styles.label} htmlFor="professionalAddress">
                  Adresse professionelle <span className={styles.required}>*</span>
                </label>
              </div>
              
              {/* Country */}
              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="country"
                  placeholder=" "
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                />
                <label className={styles.label} htmlFor="country">
                  Pays <span className={styles.required}>*</span>
                </label>
              </div>
              
              {/* City */}
              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="city"
                  placeholder=" "
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
                <label className={styles.label} htmlFor="city">
                  Ville <span className={styles.required}>*</span>
                </label>
              </div>
              
              {/* Phone number */}
              <div className={styles.formGroup}>
                <input
                  type="tel"
                  id="phoneNumber"
                  placeholder=" "
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <label className={styles.label} htmlFor="phoneNumber">
                  Numéro de téléphone <span className={styles.required}>*</span>
                </label>
              </div>
              {/* Email */}
              <div className={styles.formGroup}>
                <input
                  type="email"
                  id="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                />
                <label className={styles.label} htmlFor="email">
                  Email <span className={styles.required}>*</span>
                </label>
              </div>
              
              {/* Medical license number */}
              <div className={styles.formGroup}>
                <input
                  type="number"
                  id="medicalLicenseNumber"
                  placeholder=" "
                  value={medicalLicenseNumber}
                  onChange={(e) => setMedicalLicenseNumber(e.target.value)}
                />
                <label className={styles.label} htmlFor="medicalLicenseNumber">
                  Numéro d'inscription à l'ordre de médecins dentistes
                </label>
              </div>

              <button type="submit" className={`${styles.submitBtn} ${styles.cta}`}>
                Créez votre compte
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default GetStarted;